import { FeatureFlag } from '../FeatureFlag';
import { z } from 'zod';

const LegacyLabPoolIdsSchema = z.array(z.string());

/**
 * Ids of legacy LAB inventory pools — pools served by the legacy SQL OMS
 * rather than the modern inventory backend. The UI hides or disables
 * modern-pool-only features for pools in this set (PLAT-12869).
 * Payload: a JSON array of pool id strings; defaults to no legacy pools.
 */
export const legacyLabPools = new FeatureFlag<string[]>({
    key: 'legacy-lab-pools',
    createdOn: '2026-07-28',
    defaultValue: [],
    parseValue: (value) => LegacyLabPoolIdsSchema.parse(value),
});
